import { isCashFormat } from "../A6Transactions/utils";
import { FixingMode } from "@/data/fixingMode";
import { AssetClass2ByFixingMode } from "@/data/assetClass2ByFixingMode";

/**
 * Default categorisation for price
 */
export const DEFAULT_PRICE_CATEGORISATION: AssetClass2ByFixingMode = {
  valorisation: [
    "art",
    "jewel",
    "hedge_fund_unlisted",
    "other_alternative_non_listed",
    "building",
    "personal_use_real_estate",
    "fonds_euros",
    "relatives_debt",
    "private_equity_fund",
    "scpi_usufruit",
  ],
  NA: ["home_loan", "other_loan"],
};

export function computeFixingMode(
  assetClass2?: string,
  assetName?: string,
): FixingMode | null {
  if (!assetClass2 || !assetName) return null;

  const isCashAsset = isCashFormat(assetName);
  if (isCashAsset) return "NA";

  const asset_class_2 = assetClass2.trim().toLowerCase();
  if (
    DEFAULT_PRICE_CATEGORISATION.valorisation
      .map((s) => s.toLowerCase())
      .includes(asset_class_2)
  )
    return "valorisation";
  if (
    DEFAULT_PRICE_CATEGORISATION.NA.map((value) =>
      value.toLowerCase(),
    ).includes(asset_class_2)
  )
    return "NA";
  return "fixing";
}

const isFiniteNumber = (v: unknown): boolean =>
  typeof v === "number" && Number.isFinite(v);

export const requiresMarketValue = (data: any) => {
  const assetClass2 = data?.a6_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== FixingMode.VALORISATION || isFiniteNumber(data.market_value);
};

export const requiresFixing = (data: any) => {
  const assetClass2 = data?.a6_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== FixingMode.FIXING || isFiniteNumber(data.fixing);
};
